package com.platforma.chat_domain.use_case

import com.platforma.chat_domain.model.DraftDomain
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.transform
import team.platforma.chat_data.repository.draft.DraftRepository

class DraftTableUseCase(
    private val repository: DraftRepository
) {
    suspend fun createNewDraft(aiModelId: Long, userId: Long, chatId: Long) {
        repository.insertDraft(aiModelId, userId, chatId)
    }

    fun observeDrafts(aiModelId: Long?, userId: Long, chatId: Long): Flow<List<DraftDomain>> = repository
        .observeDraftList(aiModelID = aiModelId, userID = userId, chatID = chatId)
        .transform { value ->
            val list = value.map {
                DraftDomain(
                    draftId = it.draftID,
                    aiModelId = it.aiModelID,
                    userId = it.userID,
                    chatId = it.chatID,
                    text = it.text
                )
            }
            return@transform emit(list)
        }

    suspend fun updateDraftText(draftId: Long, text: String, chatId: Long){
        repository.updateDraftText(draftId, text, chatId)
    }
}